import React, { Component, Fragment } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import HeaderInputModifying from "./components/HeaderInputModifying";
import * as R from "ramda";
import FlexView from "react-flexview";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { tableColumns, downloadPdf, printPDF } from "./config";
import PenyerahanBBNLeasingDetail from "./penyerahanBBNLeasingDetail";
import Api from "../../../../Services/Api";
import { contructQueryParam } from "../../../../Services/Utils";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import M from "moment";
import { GenericSequenceType } from "../../../common/Constants";
import SimplePrintButton from "../../../../modules/SimplePrintButton";
import {fetchDataAsync} from "../../../../Services/Utils";
import { constructPayloadExport } from "../penyerahanBBNIndividu/util";

class PenyerahanBBNLeasingModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modifyingModalVisible: false,
            tableColumns: [...tableColumns.secondPage],
            dataTable: [],
            dataTableDetail: [],
            dataTableDetailChanged: [],
            dataRollBackTableDetail: [],
            dataExport: null,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.fetchDataLeasing();
        if (R.or(R.equals(this.props.action, "edit"), R.equals(this.props.action, "view"))) {
            await this.fetchData();
        }
        if (R.equals(this.props.action, "create")) {
            const kodeCabang = this.props.selectedCabang?.value;
            let handOverNumber = await this.fetchDataGenerateSeq(this.constructGenSeqPayload(kodeCabang));
            this.props.setValue("handOverNumber", handOverNumber);
            this.props.setValue("periodHandOver", M(new Date()).format("DD-MM-YYYY"));
        }

        await this.fetchDataTableDetail();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps) => {
        if (prevProps.controls.leasingId !== this.props.controls.leasingId) {
            this.handleTriggerLoading();
            await this.fetchDataTableDetail();
            this.handleTriggerLoading();
        }
    }

    constructGenSeqPayload = (kodeCabang) => {
        return {
            seqType: GenericSequenceType.BBN_BPKB_LEASING,
            nosDealerCode: kodeCabang,
            transactionType: GenericSequenceType.BBN_BPKB_LEASING,
        }
    }

    handleModifyingModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            modifyingModalVisible: !prevValue.modifyingModalVisible,
        }));
    };

    handleCheckedDetail = (index, e) => {
        const isChecked = e.target.checked;
        const updatedStatus = isChecked ? "Received" : "Ready";

        this.setState((prevState) => {
            const updatedDataTableDetail = prevState.dataTableDetail.map((item, i) => {
                if (i === index) {
                    return {
                        ...item,
                        bpkbStatus: updatedStatus,
                    };
                }
                return item;
            });

            return {
                ...prevState,
                dataTableDetail: updatedDataTableDetail,
                dataTableDetailChanged: updatedDataTableDetail,
            };
        });
    }

    handleSubmitSearchDetail = (filteredData) => {
        this.setState((prevState) => ({
            ...prevState,
            dataTableDetail: filteredData,
        }))
    }

    handleResetDetail = () => {
        this.setState((prevState) => ({
            ...prevState,
            dataTableDetail: prevState.dataTableDetailChanged,
        }))
    }

    handleRollBackDetail = () => {
        this.setState((prevState) => ({
            ...prevState,
            dataTableDetail: prevState.dataRollBackTableDetail,
            dataTableDetailChanged: prevState.dataRollBackTableDetail,
        }))
    }

    handleSubmitForDaftBBNLeasing = (draft) => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: draft.filter(data => data.bpkbStatus === "Received"),
            dataTableDetailChanged: draft,
            dataRollBackTableDetail: draft,
        }))
        this.props.setValue("detail", draft.filter(data => data.bpkbStatus === "Received").map(item => item.processBbnId))
        this.handleModifyingModalVisibility();
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    }

    handleChangeLeasing = (name, value) => {
        this.props.setValue(name, value);
        this.props.setValue("detail", []);
        this.setState((prevState) => ({
            ...prevState,
            dataTable: [],
        }))
    }

    handlePrint = async (value) => {
        try {
            if (value !== null && R.equals(value, "excel")) {
                let reqBody;
                const { action, controls } = this.props;
                const { dataExport, dataTable } = this.state;
                if (R.equals(action, "view")) {
                    reqBody = dataExport;
                } else {
                    reqBody = constructPayloadExport(controls, dataTable)
                }

                if (reqBody) {
                    const res = await Api.create("NAGAMAS_TRANSACTION_FILE").exportToExcelBBNLeasing(reqBody);
                    if (res.ok) {
                        const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "Penyerahan_BBN_Leasing.xlsx";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    }
                }
            } else {
                this.handlePrintPdf();
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handlePrintPdf = async () => {
        let payload;
        const { action, controls } = this.props;
        const { dataExport, dataTable } = this.state;

        const listBPKB = dataTable.map((item) => ({
            bookNo: item.bookNumber,
            nameAddress: `${item.stnkName}/${item.address}`,
            policeNumber: item.policeNumber || "",
            bpkbNumber: item.numberBPKB,
            fakturNumber: item.facture,
        }));

        payload = {
            kabKotName: dataExport?.dataCabang?.kabKotName,
            leasingName: dataExport?.leasing?.leasingName,
            dataListBPKB: listBPKB,
            recipientName: dataExport?.receiptName,
            printCount: 0
        }

        if (action === 'create' || action === 'edit') {

            payload = {
                kabKotName: dataExport?.dataCabang.kabKotName,
                leasingName: controls.leasingId?.value.label,
                // jabatan: controls.jabatan.value,
                // contactNumber: controls.contactNumber?.value,
                // leasingEmployeeId: controls.idPegawai?.value,
                dataListBPKB: listBPKB,
                recipientName: controls.receiptName?.value,
                printCount: 0
            }
        }
        console.log('aw')

        try {
            const response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT").generateCetakanPenyerahanBBNLeasing,
                setError: this.props.setError,
                menuName: "Penyerahan BBN - Leasing",
                args: payload,
            });
            if (response.ok) {
                const filename = `Penyerahan_BPKB_Leasing_${M().format("DDMMYYYY")}.pdf`;
                printPDF(response.data, filename);
            }
        } catch (error) {
            console.log(error)
        }

    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        try {
            const res = await Api.create("NAGAMAS_TRANSACTION").findDetailPenyerahanBBNLeasing(
                contructQueryParam({ handOverNumber: this.props.controls.handOverNumber.value })
            );
            if (res.ok) {
                let data = res.data.data;
                this.props.setValue("handOverNumber", data.handOverNumber);
                this.props.setValue("periodHandOver", data.periodHandOver);
                this.props.setValue("leasingId", mapToObjectDDL(data.leasing?.leasingName, data.leasing?.leasingId));
                this.props.setValue("receiptName", data.receiptName);
                this.props.setValue("contactNumber", data.contactNumber);
                this.props.setValue("jabatan", data.jabatan);
                this.props.setValue("idPegawai", data.leasingEmployeeId);
                this.props.setValue("detail", data.detail.map(item => item.processBbnId));

                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: data.detail,
                    dataExport: data
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataTableDetail = async () => {
        try {
            const leasingId = this.props.controls.leasingId.value?.value;
            const res = await Api.create("NAGAMAS_TRANSACTION").findBPKBReady({
                handOverNumber: this.props.controls.handOverNumber.value,
                kodeCabang: this.props.selectedCabang?.value,
                leasingId: leasingId
            });
            if (res.ok) {
                this.props.setValue("detail", res.data?.data?.filter(data => data.bpkbStatus === "Received").map(item => item.processBbnId))
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: !R.isNil(leasingId) ? res.data.data.filter(data => data.bpkbStatus === "Received") : [],
                    dataTableDetail: res.data.data,
                    dataTableDetailChanged: res.data.data,
                    dataRollBackTableDetail: res.data.data
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataLeasing = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing({
                paramFilters: { listKodeCabang: [this.props.selectedCabang?.value] },
            });
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataLeasing: res.data?.data?.map(item => mapToObjectDDL(item.leasingName, item.leasingId)),
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(body);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <Fragment>
                <SimpleModal
                    title="Detail Penyerahan BBN Pelanggan"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <HeaderInputModifying
                                {...this.props}
                                changeLeasing={this.handleChangeLeasing}
                                dataLeasing={this.state.dataLeasing}
                            />
                            <SimpleDataTable
                                key={`${this.state.dataTable?.length}-${pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                toCount={this.state.dataTable?.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />

                            <div style={{ textAlign: "right", marginTop: "20px" }}>
                                <FlexView hAlignContent={"right"}>
                                    {R.or(R.equals(this.props.action, "edit"), R.equals(this.props.action, "create")) && (
                                        <SimpleButton
                                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                                            text={"Tambah"}
                                            onClick={() => this.handleModifyingModalVisibility()}
                                        />
                                    )}
                                    <SimplePrintButton
                                        styles={{ width: "220px" }}
                                        text="Cetak Bukti Serah Terima BPKB"
                                        toPdf
                                        toExcel
                                        onPrint={(value) => this.handlePrint(value)}
                                    />
                                    {R.or(R.equals(this.props.action, "edit"), R.equals(this.props.action, "create")) && (
                                        <SimpleButton
                                            type="button"
                                            text="Simpan"
                                            onClick={() => this.handleSubmit()}
                                        />
                                    )}

                                </FlexView>

                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.modifyingModalVisible && (
                    <PenyerahanBBNLeasingDetail
                        {...this.props}
                        dataTable={this.state.dataTableDetail}
                        dataTableChanged={this.state.dataTableDetailChanged}
                        dataRollBackTable={this.state.dataRollBackTableDetail}
                        selectedCabang={this.props.selectedCabang}
                        visible={this.state.modifyingModalVisible}
                        handleCheckedDetail={this.handleCheckedDetail}
                        handleSubmitSearchDetail={this.handleSubmitSearchDetail}
                        handleResetDetail={this.handleResetDetail}
                        handleRollBackDetail={this.handleRollBackDetail}
                        onSubmitDetail={this.handleSubmitForDaftBBNLeasing}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading} />
            </Fragment>
        );
    }
}

export default withFormGroup(PenyerahanBBNLeasingModifying);
